import { memo } from 'react';
import { ReactComponent as UnavailableSeatIcon } from '@eti/assets/icons/seating-buttons/default/seatButton-unavailable.svg';
import { css, cx } from '@eti/styles';
import { Button } from '@etg/wings';
import { seatButtonStyles } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const unavailableStyles = css`
  cursor: not-allowed;
  pointer-events: none;
`;
const UnavailableSeat = ({
  seatTypeLabel
}) => {
  return /*#__PURE__*/_jsx(Button, {
    "aria-label": seatTypeLabel,
    className: cx(seatButtonStyles, unavailableStyles),
    isDisabled: true,
    children: /*#__PURE__*/_jsx(UnavailableSeatIcon, {
      "aria-hidden": "true"
    })
  });
};
export default /*#__PURE__*/memo(UnavailableSeat);
//# sourceMappingURL=UnavailableSeat.js.map